import { render, staticRenderFns } from "./actionButton.vue?vue&type=template&id=6406b328&"
import script from "./actionButton.vue?vue&type=script&lang=js&"
export * from "./actionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports